module["exports"] = [];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/az/name/prefix.js
// module id = 194
// module chunks = 0